import { null as zNull } from "zod";

export const disconnectGlobalEIntegration = {
  name: "disconnectGlobalEIntegration" as const,
  input: zNull(),
  output: zNull(),
};
